<template>
  <div
    class="sticky t-0 z-1 w-full overflow-visible shrink-0 flex-col bg-color-pop-16"
  >
    <div class="w-full overflow-visible shrink-0 flex-col min-h-76 px-30">
      <div class="flex-1 flex items-center relative z-2">
        <div class="text-20 font-700 w-full text-color-0 pr-30 py-10">
          <span>{{ title }}</span>
          <slot></slot>
        </div>
      </div>
      <div
        class="absolute z-3 px-20 t-0 r-0 flex items-center justify-center h-76"
      >
        <i
          @click="handleClose"
          class="inline-block h-[max-content] w-[max-content] icon sysicon-new-clean-3 cursor-pointer hover:-rotate-[180deg] text-color-2 hover-text-color-text-0 transition-all duration-300 text-16"
        ></i>
      </div>
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(["onclose"]);
const props = defineProps({
  title: String,

});
function handleClose() {
  emit("onclose");
}
</script>